export default __webpack_public_path__ + "static/media/telegram.49788eb8.svg";